module.exports = "<ng-content></ng-content>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/default-page/default-page.component.html
// module id = ./src/app/shared/components/default-page/default-page.component.html
// module chunks = main